import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(
    private http: HttpClient
  ) { }

  getUsers() {
    return (this.http.get(`${environment.apiUrl}/users`));
  }

  createUser(data: any) {
    return (this.http.post(`${environment.apiUrl}/users`, data));
  }

  updateUser(data: any) {
    return (this.http.put(`${environment.apiUrl}/users/${data.id}`, data));
  }

  deleteUser(id: number) {
    return (this.http.delete(`${environment.apiUrl}/users/${id}`));
  }

  getRoles() {
    return this.http.get(`${environment.apiUrl}/users/roles`);
  }

}
